import { Component } from '@angular/core';
import { MatDialog } from '@angular/material';
import { AuthService } from 'app/core/auth.service';
import { ReactionService } from 'app/core/reaction.service';
import { ReactionBaseComponent } from 'app/shared-ui/reaction/reaction-base/reaction-base.component';

@Component({
  selector: 'app-reaction',
  templateUrl: './reaction.component.html',
  styleUrls: ['./reaction.component.scss'],
})
export class ReactionComponent extends ReactionBaseComponent {
  constructor(
    reactionService: ReactionService,
    authService: AuthService,
    dialog: MatDialog
  ) {
    super(reactionService, authService, dialog);
  }
}
